import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 根据工作号uuid获取
export function getWarehouseIn(params) {
  return request({
    url: URL.warehouseIn.warehouseIn,
    method: 'get',
    params
  })
}

// 根据工作号uuid获取
export function putWarehouseIn(data) {
  return request({
    url: URL.warehouseIn.warehouseIn,
    method: 'put',
    data
  })
}

// 添加包装至进仓单
export function addPackageToWarehouseIn(data) {
  return request({
    url: URL.warehouseIn.addPackageToWarehouseIn,
    method: 'post',
    data
  })
}

// 自动配货
export function autoAllocateCargo(data) {
  return request({
    url: URL.warehouseIn.autoAllocateCargo,
    method: 'post',
    data
  })
}

// 一键进仓
export function batchIncome(params) {
  return request({
    url: URL.warehouseIn.batchIncome,
    method: 'post',
    params
  })
}

// 清除进仓信息
export function clearPackageIncome(data) {
  return request({
    url: URL.warehouseIn.clearPackageIncome,
    method: 'post',
    data
  })
}

// 仓库记录查询
export function complexQuery(data) {
  return request({
    url: URL.warehouseIn.complexQuery,
    method: 'post',
    data
  })
}

// 删除进仓单
export function deleteWarehouseIn(params) {
  return request({
    url: URL.warehouseIn.deleteWarehouseIn,
    method: 'post',
    params
  })
}
// 批量删除进仓单
export function batchDeleteWarehouseIn(data) {
  return request({
    url: URL.warehouseIn.batchDeleteWarehouseIn,
    method: 'post',
    data
  })
}

// 编辑包装
export function editPackage(data) {
  return request({
    url: URL.warehouseIn.editPackage,
    method: 'post',
    data
  })
}

// 对包装进行进仓操作
export function income(data) {
  return request({
    url: URL.warehouseIn.income,
    method: 'post',
    data
  })
}

// 查询待进仓的包装列表
export function queryNeedWarehouseInPackageList(data) {
  return request({
    url: URL.warehouseIn.queryNeedWarehouseInPackageList,
    method: 'post',
    data
  })
}

// 获取进仓单明细统计信息
export function queryPoPackageSumInfo(data) {
  return request({
    url: URL.warehouseIn.queryPoPackageSumInfo,
    method: 'post',
    data
  })
}

// 获取进仓单
export function queryWarehouseIn(params) {
  return request({
    url: URL.warehouseIn.queryWarehouseIn,
    method: 'post',
    params
  })
}

// 查询进仓单下的包装列表
export function queryWarehouseInDetailPageable(data) {
  return request({
    url: URL.warehouseIn.queryWarehouseInDetailPageable,
    method: 'post',
    data
  })
}

// 查询进仓通知单列表
export function queryWarehouseInPageable(data) {
  return request({
    url: URL.warehouseIn.queryWarehouseInPageable,
    method: 'post',
    data
  })
}

// 从进仓单移除包装
export function removePackageFromWarehouseIn(data) {
  return request({
    url: URL.warehouseIn.removePackageFromWarehouseIn,
    method: 'post',
    data
  })
}

// 货物信息解除
export function unLock(data) {
  return request({
    url: URL.warehouseIn.unLock,
    method: 'post',
    data
  })
}

// 前端手动装箱
export function uploadPhotoData(data) {
  return request({
    url: URL.warehouseIn.uploadPhotoData,
    method: 'post',
    data
  })
}

// 保存进仓单
export function saveWarehouseIn(data) {
  return request({
    url: URL.warehouseIn.saveWarehouseIn,
    method: 'post',
    data
  })
}

// 查询进仓单下文件列表
export function queryBusinessDocument(params) {
  return request({
    url: URL.warehouseIn.queryBusinessDocument,
    method: 'post',
    params
  })
}

// 删除进仓照片
export function deletePhotoFile(params) {
  return request({
    url: URL.warehouseIn.deletePhotoFile,
    method: 'post',
    params
  })
}

// 批量删除进仓照片
export function batchDeletePhotoFile(data) {
  return request({
    url: URL.warehouseIn.batchDeletePhotoFile,
    method: 'post',
    data
  })
}

// 拆单
export function splitWarehouseIn(data) {
  return request({
    url: URL.warehouseIn.splitWarehouseIn,
    method: 'post',
    data
  })
}

// 拆单
export function oneKeyIncome(params) {
  return request({
    url: URL.warehouseIn.oneKeyIncome,
    method: 'post',
    params
  })
}

// 下载文件
export function downloadFile(params) {
  return request({
    url: URL.warehouseIn.downloadFile,
    method: 'post',
    responseType: 'blob',
    params
  })
}

// 导出包装列表
export function exportNeedWarehouseInPackage(data) {
  return request({
    url: URL.warehouseIn.exportNeedWarehouseInPackage,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 导出包装列表
export function exportBatchNeedWarehouseInPackage(data) {
  return request({
    url: URL.warehouseIn.exportBatchNeedWarehouseInPackage,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 导出库存报告
export function exportInventoryReport(data) {
  return request({
    url: URL.warehouseIn.exportInventoryReport,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 导出进仓明细
export function exportWarehouseInPackageDetail(data) {
  return request({
    url: URL.warehouseIn.exportWarehouseInPackageDetail,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 车辆类型
export function queryVehicleType(data) {
  return request({
    url: URL.warehouseIn.queryVehicleType,
    method: 'get',
    data
  })
}
// 查询订单sku
export function queryWarehousePoPackage(params) {
  return request({
    url: URL.warehouseIn.queryWarehousePoPackage,
    method: 'post',
    params
  })
}
